import { Component, forwardRef, inject, resource, signal } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { SimpleApi } from '@core/api/simple.api';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-pengeinstitut-select',
  imports: [SelectModule, FormsModule],
  templateUrl: './pengeinstitut-select.component.html',
  styleUrl: './pengeinstitut-select.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PengeinstitutSelectComponent),
      multi: true,
    },
  ],
})
export class PengeinstitutSelectComponent implements ControlValueAccessor {
  simpleApi = inject(SimpleApi);

  data = resource({
    loader: async () => {
      return await this.simpleApi.getList(
        '/api/admin/pengeinstitutter/dropdown'
      );
    },
  });

  valueSignal = signal<number | undefined>(undefined);
  isDisabled = false;

  private onChange: any = () => {};
  private onTouch: any = () => {};

  writeValue(value: number): void {
    this.valueSignal.set(value); // Update the signal when the value changes
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onValueChange(newValue: any): void {
    this.valueSignal.set(newValue);
    this.onChange(newValue);
    this.onTouch();
  }
}
